import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Container, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'grid',
        placeItems: 'center',
        minHeight: '90vh',
    },
    message: {
        textAlign: 'center',
    },
}))

export const Error = ({ error }) => {
    const classes = useStyles()
    return (
        <Container className={classes.container}>
            <Typography className={classes.message} variant="h6" component="p" color="textSecondary">
                {error}
            </Typography>
        </Container>
    )
}
